export default __webpack_public_path__ + "static/media/memTeam1.f928fad3.png";